export default __webpack_public_path__ + "/dist/images/promote-icon.9d642a1f21e711a69cd60ea57e542622.svg";